import { Stack } from 'react-bootstrap'

import { DataPackages } from '@piv/lib/rest-queries'
import { Filter } from '@piv/portal/primitives/Filter'

import { ClearFiltersButtonRow } from './ClearFiltersButtonRow'
import { useInventoryFilterParams } from './useInventoryFilterParams'

export function InventoryFilters() {
  const { filters, filterSetters } = useInventoryFilterParams()
  const query = DataPackages.useFilters(filters)

  return (
    <Stack gap={3}>
      <ClearFiltersButtonRow id="filters-clear-button" />

      <Filter
        loading={query.isFetching}
        title="Assets"
        items={query.data?.asset ?? []}
        selectedKeys={filters.asset}
        onSelectionChanged={filterSetters.asset}
      />
      <Filter
        loading={query.isFetching}
        title="Product"
        items={query.data?.products ?? []}
        selectedKeys={filters.products}
        onSelectionChanged={filterSetters.products}
        showSearch
      />
      <Filter
        loading={query.isFetching}
        title="Instrument"
        items={query.data?.instruments ?? []}
        selectedKeys={filters.instruments}
        onSelectionChanged={filterSetters.instruments}
        showSearch
      />
      <Filter
        loading={query.isFetching}
        title="Sub-assets"
        items={query.data?.subAsset ?? []}
        selectedKeys={filters.subAsset}
        onSelectionChanged={filterSetters.subAsset}
        showSearch
      />
      <Filter
        loading={query.isFetching}
        title="Desk Regions"
        items={query.data?.region ?? []}
        selectedKeys={filters.region}
        onSelectionChanged={filterSetters.region}
        hint={`Indicates regions where included instruments are traded. For instance a USA Government Bond might be traded on desks in London and New York, so would be listed here as EMEA and AMER`}
      />
      <Filter
        loading={query.isFetching}
        title="Brands"
        items={query.data?.brand ?? []}
        selectedKeys={filters.brand}
        onSelectionChanged={filterSetters.brand}
      />
      <Filter
        loading={query.isFetching}
        title="Currencies"
        items={query.data?.currency ?? []}
        selectedKeys={filters.currency}
        onSelectionChanged={filterSetters.currency}
        showSearch
      />
    </Stack>
  )
}
